import * as React from 'react';
import { FC } from 'react';
import omit from 'lodash/omit';

export const omitComponentProps: (
  Component: any,
  omitsProps: string[],
) => FC<any> =
  (Component, omitsProps) =>
  ({ children, ...rest }) => {
    const newProps = omit(rest, omitsProps);
    return <Component {...newProps}>{children}</Component>;
  };
